var _ICON_SIZES, _SQUIRCLE_BUTTON_SIZE;

import { ButtonSize } from '../Button';
import { SquircleButtonVariant } from './SquircleButton.decl';
export var makeSquircleButtonVariant = function makeSquircleButtonVariant(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly;
  var colors = theme.colors;

  if (variant !== SquircleButtonVariant.DEFAULT) {
    return;
  }

  if (disabled) {
    return {
      backgroundColor: colors.base.white,
      borderColor: colors.base.white,
      svg: {
        fill: colors.secondary.lighter
      }
    };
  }

  return {
    backgroundColor: colors.base.white,
    borderColor: colors.base.white,
    svg: {
      fill: colors.secondary.base
    },
    ':hover': readOnly ? undefined : {
      backgroundColor: colors.grey.lighter,
      borderColor: colors.grey.lighter,
      svg: {
        fill: colors.secondary.base
      }
    },
    ':active': readOnly ? undefined : {
      backgroundColor: colors.grey.base,
      borderColor: colors.grey.base,
      svg: {
        fill: colors.secondary.base
      }
    },
    ':focus': readOnly ? undefined : {
      backgroundColor: colors.grey.base,
      borderColor: colors.grey.lighter,
      svg: {
        fill: colors.secondary.base
      }
    }
  };
};
export var ICON_SIZES = (_ICON_SIZES = {}, _ICON_SIZES[ButtonSize.SMALL] = '24px', _ICON_SIZES[ButtonSize.REGULAR] = '32px', _ICON_SIZES[ButtonSize.LARGE] = '40px', _ICON_SIZES);
export var SQUIRCLE_BUTTON_SIZES = (_SQUIRCLE_BUTTON_SIZE = {}, _SQUIRCLE_BUTTON_SIZE[ButtonSize.SMALL] = {
  width: '40px',
  height: '40px'
}, _SQUIRCLE_BUTTON_SIZE[ButtonSize.REGULAR] = {
  width: '56px',
  height: '56px'
}, _SQUIRCLE_BUTTON_SIZE[ButtonSize.LARGE] = {
  width: '64px',
  height: '64px'
}, _SQUIRCLE_BUTTON_SIZE); // Props that should not be forwarded to the HTML DOM elements

export var shouldForwardProp = function shouldForwardProp(prop) {
  return !['shape'].includes(prop);
};